import { getMessaging, getToken } from "firebase/messaging";
import { checkSupportsNotifications } from "../notifications/utils/check-supports-notification";
import { app } from "./app";

export const messaging = checkSupportsNotifications() 
  ? getMessaging(app)
  : null;